// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15tVX","badges":"styles_badges__Q1kdw"};